/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Channel_ReminderInputs */

const en_us2_push_channel_reminder = /** @type {(inputs: Push_Channel_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training reminders`)
};

const pt_br2_push_channel_reminder = /** @type {(inputs: Push_Channel_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lembretes de treino`)
};

const es_419_push_channel_reminder = /** @type {(inputs: Push_Channel_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recordatorios de entrenamiento`)
};

const pt_pt2_push_channel_reminder = /** @type {(inputs: Push_Channel_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lembretes de treino`)
};

const fr_fr2_push_channel_reminder = /** @type {(inputs: Push_Channel_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rappels d'entraînement`)
};

const de_de2_push_channel_reminder = /** @type {(inputs: Push_Channel_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainingserinnerungen`)
};

const it_it2_push_channel_reminder = /** @type {(inputs: Push_Channel_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promemoria di allenamento`)
};

/**
* | output |
* | --- |
* | "Training reminders" |
*
* @param {Push_Channel_ReminderInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const push_channel_reminder = /** @type {((inputs?: Push_Channel_ReminderInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Channel_ReminderInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_push_channel_reminder(inputs)
	if (locale === "es-419") return es_419_push_channel_reminder(inputs)
	if (locale === "pt-PT") return pt_pt2_push_channel_reminder(inputs)
	if (locale === "fr-FR") return fr_fr2_push_channel_reminder(inputs)
	if (locale === "de-DE") return de_de2_push_channel_reminder(inputs)
	if (locale === "it-IT") return it_it2_push_channel_reminder(inputs)
	return en_us2_push_channel_reminder(inputs)
});
export { push_channel_reminder as "push.channel_reminder" }